import { createContext, useContext } from 'react';

export interface EnvironmentPreferences {
  tutorial_on?: boolean;
  google_auth_on?: boolean;
  sign_up_on?: boolean;
  bug_reporting_on?: boolean;
  thumbnail_gen_on?: boolean;
  advanced_upload_wizard_on?: boolean;
  keyframes_on?: boolean;
  undo_on?: boolean;
  redo_on?: boolean;
  external_assets_on?: boolean;
  templates?: boolean;
  geospatial?: boolean;
  spectacles?: boolean;
  material_picker_on?: boolean;
}

interface EnvironmentPreferencesContextType {
  environmentPreferences: EnvironmentPreferences | null;
  loading: boolean;
  failed: boolean;
  retry: () => void;
}

export const EnvironmentPreferencesContext = createContext<EnvironmentPreferencesContextType>({
  environmentPreferences: null,
  loading: true,
  failed: false,
  retry: () => {},
});

export const useEnvironmentPreferences = () => useContext(EnvironmentPreferencesContext);
